import { useAccount, useBalance, useReadContract } from 'wagmi';
import { formatUnits } from 'viem';
import { ERC20_ABI } from '../config/abi';

// DUCK Token Contract Address (from env or placeholder)
const DUCK_TOKEN_ADDRESS = import.meta.env.VITE_DUCK_TOKEN_ADDRESS as `0x${string}` || '0x0000000000000000000000000000000000000000';

export function useTokenBalance() {
    const { address, isConnected } = useAccount();

    // Get MON (native) balance
    const { data: monBalance, isLoading: monLoading } = useBalance({
        address: address,
    });

    // Get DUCK token balance
    const { data: duckBalanceRaw, isLoading: duckLoading } = useReadContract({
        address: DUCK_TOKEN_ADDRESS,
        abi: ERC20_ABI,
        functionName: 'balanceOf',
        args: address ? [address] : undefined,
        query: {
            enabled: isConnected && !!address,
        },
    });

    // Format DUCK balance (assuming 18 decimals)
    const duckBalance = duckBalanceRaw ? formatUnits(duckBalanceRaw as bigint, 18) : '0';

    return {
        isConnected,
        address,
        mon: {
            balance: monBalance?.formatted || '0',
            symbol: monBalance?.symbol || 'MON',
            isLoading: monLoading,
        },
        duck: {
            balance: duckBalance,
            symbol: 'DUCK',
            isLoading: duckLoading,
        },
    };
}

export function useWalletInfo() {
    const { address, isConnected, connector } = useAccount();
    const { data: balance } = useBalance({ address });

    return {
        address,
        isConnected,
        connectorName: connector?.name,
        balance: balance?.formatted,
        symbol: balance?.symbol,
    };
}
